import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import "rc-tooltip/assets/bootstrap_white.css";

import { addToBreadCrumpData, popBreadCrumpOnPageClose, findPrevPathFromBreadCrumpData, removeAllTags } from "../../../config/utils";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";
import qs from "query-string";
import ShowHelperModal from "../../helper/components/ShowHelperModal";
import { AssetMainTab } from "./AssetMainTab";
import AssetFieldVisibilityModal from "../fieldVisibility/AssetFieldVisibilityModal";
import {
    getRequiredAssetViewFieldKeys,
    resolveAssetViewFieldConfig,
    recomputeAssetViewFieldConfig,
    saveAssetViewFieldConfig,
    resetAssetViewFieldConfig,
    isAssetViewFieldConfigChanged,
    enforceRequiredFieldVisibility,
    getHiddenAssetViewFieldCount,
    bootstrapAssetViewFieldConfig,
    getDynamicBandsSignature
} from "../fieldVisibility/assetViewFieldConfigUtils";
import { hasStoredAssetViewTableSettings, buildAssetViewFieldCacheKey } from "../fieldVisibility/assetViewFieldConfigCache";
import { alignAssetViewFieldConfigOrder } from "../fieldVisibility/assetViewFieldConfig";
import "../../building/fieldVisibility/fieldVisibilityButton.css";
// import helpIcon from "../../../assets/img/question-mark-icon.png";

class BasicDetails extends Component {
    state = {
        showConfirmModalLog: false,
        selectedLog: "",
        logChanges: {},
        showHelperModal: false,
        selectedHelperItem: {},
        showConfirmModal: false,
        showImageModal: false,
        assetViewFieldConfig: null,
        initialAssetViewFieldConfig: null,
        showFieldVisibilityModal: false,
        fieldConfigLoading: false,
        fieldConfigReady: false
    };

    componentDidMount() {
        if (this.getFieldConfigContext().clientId) {
            this.loadAssetViewFieldSettings();
        }
    }

    componentDidUpdate(prevProps) {
        const prevClientId = prevProps.basicDetails?.client?.id;
        const nextClientId = this.props.basicDetails?.client?.id;
        if (nextClientId && prevClientId !== nextClientId) {
            this.loadAssetViewFieldSettings({ refetch: !!prevClientId });
        } else if (getDynamicBandsSignature(prevProps.dynamicBands) !== getDynamicBandsSignature(this.props.dynamicBands)) {
            this.recomputeFieldConfigFromCache();
        }
    }

    getFieldConfigContext = () => {
        const { basicDetails, dynamicBands = {} } = this.props;
        const query = qs.parse(this.props.location?.search || "");
        const role = localStorage.getItem("role") || "";
        const clientId = basicDetails?.client?.id || query.client_id || query.c_id || "";
        return { role, clientId, dynamicBands, assetState: basicDetails || {} };
    };

    isFieldVisibilityEditable = () => (localStorage.getItem("role") || "") === "super_admin";

    canCustomizeFields = () => this.isFieldVisibilityEditable() && !!this.getFieldConfigContext().clientId;

    applyFieldConfigState = fieldConfig => {
        this.setState({
            assetViewFieldConfig: fieldConfig,
            initialAssetViewFieldConfig: fieldConfig,
            fieldConfigReady: true,
            fieldConfigLoading: false
        });
    };

    recomputeFieldConfigFromCache = () => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        if (!clientId) {
            this.applyFieldConfigState(bootstrapAssetViewFieldConfig(dynamicBands, "view"));
            return;
        }
        const fieldConfig = recomputeAssetViewFieldConfig({ clientId, dynamicBands, role, assetState, layoutContext: "view" });
        this.applyFieldConfigState(fieldConfig);
    };

    loadAssetViewFieldSettings = async ({ refetch = false } = {}) => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        if (!clientId) {
            this.applyFieldConfigState(bootstrapAssetViewFieldConfig(dynamicBands, "view"));
            return;
        }
        const cacheKey = buildAssetViewFieldCacheKey({ clientId });
        const hasCache = !refetch && hasStoredAssetViewTableSettings(cacheKey);
        if (hasCache) {
            this.recomputeFieldConfigFromCache();
            return;
        }
        this.setState({ fieldConfigLoading: true, fieldConfigReady: false });
        try {
            const { fieldConfig } = await resolveAssetViewFieldConfig({
                clientId,
                dynamicBands,
                role,
                assetState,
                layoutContext: "view",
                refetch: true
            });
            this.applyFieldConfigState(fieldConfig);
        } catch (_e) {
            this.setState({ fieldConfigReady: true, fieldConfigLoading: false });
        }
    };

    openFieldVisibilityModal = () => {
        if (!this.canCustomizeFields()) return;
        this.recomputeFieldConfigFromCache();
        this.setState({ showFieldVisibilityModal: true });
    };

    applyFieldVisibility = async fieldConfig => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        const requiredKeys = getRequiredAssetViewFieldKeys(role, assetState, dynamicBands);
        const enforced = alignAssetViewFieldConfigOrder(enforceRequiredFieldVisibility(fieldConfig, requiredKeys), dynamicBands, "view");
        if (clientId) {
            await saveAssetViewFieldConfig({ clientId, keys: enforced.keys, config: enforced.config, dynamicBands });
        }
        this.setState({ assetViewFieldConfig: enforced, initialAssetViewFieldConfig: enforced });
    };

    resetFieldVisibility = async () => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        if (!clientId) return;
        await resetAssetViewFieldConfig({ clientId });
        const { fieldConfig } = await resolveAssetViewFieldConfig({
            clientId,
            dynamicBands,
            role,
            assetState,
            layoutContext: "view",
            refetch: false
        });
        this.setState({
            assetViewFieldConfig: fieldConfig,
            initialAssetViewFieldConfig: fieldConfig,
            showFieldVisibilityModal: false
        });
    };

    isFieldConfigChanged = () =>
        isAssetViewFieldConfigChanged(this.state.assetViewFieldConfig, this.state.initialAssetViewFieldConfig);

    renderFieldVisibilityEyeButton = () => {
        if (!this.isFieldVisibilityEditable()) return null;
        const hiddenFieldCount = getHiddenAssetViewFieldCount(this.state.assetViewFieldConfig);
        const hasHiddenFields = hiddenFieldCount > 0;
        return (
            <span
                className={`edit-icn-bx icon-btn-sec view building-field-visibility-btn building-field-visibility-btn--view${
                    this.canCustomizeFields() ? "" : " cursor-diabled"
                }${hasHiddenFields ? " building-field-visibility-btn--active" : ""}`}
                onClick={() => this.canCustomizeFields() && this.openFieldVisibilityModal()}
                data-tip={
                    this.canCustomizeFields()
                        ? hasHiddenFields
                            ? `${hiddenFieldCount} field(s) hidden — show / hide fields`
                            : "Show / hide fields"
                        : "Select a client context to customize fields"
                }
                data-for="Asset_details"
                data-place="bottom"
            >
                <img src="/img/eye-ico.svg" alt="" className="eye-ico" />
                {hasHiddenFields ? (
                    <i className="fas fa-exclamation-circle building-field-visibility-active-indicator" aria-hidden="true" />
                ) : null}
            </span>
        );
    };

    renderFieldVisibilityModal = () => {
        if (!this.state.showFieldVisibilityModal || !this.state.assetViewFieldConfig) return null;
        const { role, dynamicBands, assetState } = this.getFieldConfigContext();
        const requiredKeys = getRequiredAssetViewFieldKeys(role, assetState, dynamicBands);
        return (
            <Portal
                body={
                    <AssetFieldVisibilityModal
                        key={getDynamicBandsSignature(dynamicBands)}
                        fieldConfig={this.state.assetViewFieldConfig}
                        requiredKeys={requiredKeys}
                        showReset={this.isFieldConfigChanged()}
                        onReset={this.resetFieldVisibility}
                        onApply={this.applyFieldVisibility}
                        onCancel={() => this.setState({ showFieldVisibilityModal: false })}
                    />
                }
                onCancel={() => this.setState({ showFieldVisibilityModal: false })}
            />
        );
    };

    handleRestoreLog = async (id, choice, changes) => {
        await this.setState({
            showConfirmModalLog: true,
            selectedLog: id,
            logChanges: changes
        });
    };

    renderConfirmationModalLog = () => {
        const { showConfirmModalLog, logChanges } = this.state;
        if (!showConfirmModalLog) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to restore this log?"}
                        message={logChanges}
                        onNo={() => this.setState({ showConfirmModalLog: false })}
                        onYes={this.restoreLogOnConfirm}
                        isRestore={true}
                        type={"restore"}
                        isLogChange={true}
                    />
                }
                onCancel={() => this.setState({ showConfirmModalLog: false })}
            />
        );
    };

    restoreLogOnConfirm = async () => {
        const { selectedLog } = this.state;
        await this.props.HandleRestoreSettingsLog(selectedLog);
        await this.props.refreshinfoDetails();
        this.setState({
            showConfirmModalLog: false,
            selectedLog: null,
            isHistoryView: !this.state.isHistoryView
        });
    };

    showHelperModal = async (item, subItem) => {
        await this.setState({
            showHelperModal: true,
            selectedHelperItem: {
                item,
                subItem
            }
        });
    };

    findPriorityText = (element, options) => {
        let text = "-";
        let priorityObj = options.find(option => parseInt(option.value) === element);
        if (priorityObj) {
            text = priorityObj.name;
        }
        return text;
    };

    openImageModal = () => {
        this.setState({
            showImageModal: true
        });
    };

    showHelperModal = async (item, subItem) => {
        await this.setState({
            showHelperModal: true,
            selectedHelperItem: {
                item,
                subItem
            }
        });
    };
    renderUploadHelperModal = () => {
        const { showHelperModal, selectedHelperItem } = this.state;
        if (!showHelperModal) return null;
        return (
            <Portal
                body={<ShowHelperModal selectedHelperItem={selectedHelperItem} onCancel={() => this.setState({ showHelperModal: false })} />}
                onCancel={() => this.setState({ showHelperModal: false })}
            />
        );
    };

    exportAsset = basicDetails => {
        let params = {};
        params.client_id = basicDetails?.client?.id || "";
        params.asset_id = basicDetails?.id || "";
        params.username = localStorage.getItem("user");
        this.props.onePagerExport(params);
    };

    render() {
        const {
            basicDetails,
            handleDeleteItem,
            hasEdit,
            hasExport,
            hasDelete,
            hasLogView,
            showEditPage,
            history,
            isHistoryView,
            hasClose = true,
            imageResponse,
            dynamicBands = {}
        } = this.props;
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        return (
            <React.Fragment>
                <div className="tab-active location-sec recom-sec add-recommendation asset-viewer-outer">
                    <ReactTooltip id="Asset_details" effect="solid" className="rc-tooltip-custom-class" backgroundColor="#007bff" />
                    {this.renderUploadHelperModal()}
                    {this.renderFieldVisibilityModal()}
                    <div className="otr-edit-delte col-md-12 text-right ed-dl view-narrative-report">
                        {this.renderFieldVisibilityEyeButton()}
                        {hasExport && (
                            <>
                                {this.props.exportLoader ? (
                                    <span className="edit-icn-bx icon-btn-sec">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </span>
                                ) : (
                                    <span
                                        onClick={() => {
                                            this.exportAsset(basicDetails);
                                        }}
                                        className="edit-icn-bx icon-btn-sec"
                                        data-tip="Export"
                                        data-for="Asset_details"
                                        data-place="bottom"
                                    >
                                        <img src="/img/export-rec.svg" alt="" />
                                    </span>
                                )}
                            </>
                        )}
                        {isHistoryView
                            ? hasLogView && (
                                  <span
                                      onClick={() => {
                                          this.props.changeToHistory();
                                      }}
                                      className="edit-icn-bx"
                                  >
                                      <i className="fas fa-history"></i> View History
                                  </span>
                              )
                            : null}
                        {hasClose && !query.dashboardView ? (
                            <span
                                onClick={() => {
                                    popBreadCrumpOnPageClose();
                                    history.push(findPrevPathFromBreadCrumpData());
                                }}
                                className="edit-icn-bx"
                            >
                                <i className="fas fa-window-close"></i> Close
                            </span>
                        ) : null}

                        {!basicDetails.locked && (
                            <>
                                {hasEdit ? (
                                    basicDetails.status === "deleted" ? (
                                        <span onClick={() => this.props.showRestoreModal(basicDetails.id)} className="edit-icn-bx">
                                            <i className="fas fa-history" /> Restore
                                        </span>
                                    ) : (
                                        <span
                                            onClick={() => {
                                                if (showEditPage) {
                                                    showEditPage(this.props.match.params.id);
                                                } else {
                                                    addToBreadCrumpData({
                                                        key: "edit",
                                                        name: `Edit ${this.props.location.pathname.split("/")[1]}`,
                                                        path: `/${this.props.location.pathname.split("/")[1]}/edit/${this.props.match.params.id}`
                                                    });
                                                    history.push(`/${this.props.location.pathname.split("/")[1]}/edit/${this.props.match.params.id}`);
                                                }
                                            }}
                                            className="edit-icn-bx"
                                        >
                                            <i className="fas fa-pencil-alt"></i> Edit
                                        </span>
                                    )
                                ) : null}
                                {hasDelete && (
                                    <span onClick={() => handleDeleteItem(this.props.match.params.id, null, basicDetails)} className="edit-icn-bx">
                                        <i className="fas fa-trash-alt"></i> Delete
                                    </span>
                                )}
                            </>
                        )}
                        <span
                            className="view-inner help-icon"
                            onClick={() => {
                                this.showHelperModal("forms", "assets");
                            }}
                            data-for="Asset_details"
                            data-tip="Help"
                            // data-effect="solid"
                            data-place="bottom"
                            data-background-color="#007bff"
                        >
                            <img src="/img/question-mark-icon.png" alt="" className="fil-ico" />
                        </span>
                    </div>
                    <AssetMainTab
                        basicDetails={basicDetails}
                        imageResponse={imageResponse}
                        dynamicBands={dynamicBands}
                        fieldConfig={this.state.assetViewFieldConfig}
                        configReady={this.state.fieldConfigReady}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(BasicDetails);
